import { HStack, VStack, Text } from "@chakra-ui/react";
import { TouchableOpacity } from "components";
import { useTranslation } from "languages";
import { memo } from "react";

const SurahItem: React.FC<{
  isSelected: boolean;
  surah: any;
  onCallback: () => void;
}> = ({ isSelected, surah, onCallback }) => {
  const { translation, isArabic } = useTranslation();

  return (
    <TouchableOpacity
      direction={"row"}
      bgColor={isSelected ? "primary.300" : "secondary.300"}
      borderRadius={"xl"}
      w="full"
      py={[1.5, 3]}
      px={[2, 4]}
      justify={"space-between"}
      align={"center"}
      onClick={onCallback}
    >
      <HStack justify={"space-between"} w="full">
        <VStack gap={2} align={isArabic ? "flex-end" : "flex-start"} w="full">
          <Text
            color={isSelected ? "white" : "primary.300"}
            fontWeight={"bold"}
            fontSize={"lg"}
          >
            {isArabic ? surah?.name : surah?.englishName}
          </Text>
          <Text color={isSelected ? "white" : "secondary.800"}>
            {isArabic
              ? `${
                  surah?.revelationType === "Meccan"
                    ? translation["makkiyah"]
                    : translation["madaniyah"]
                } . ${surah?.numberOfAyahs} ${translation["verse"]} . ${
                  surah?.number
                } ${translation["no"]}`
              : `${translation["no"]} ${surah?.number} . ${
                  translation["verse"]
                } ${surah?.numberOfAyahs} . ${
                  surah?.revelationType === "Meccan"
                    ? translation["makkiyah"]
                    : translation["madaniyah"]
                }`}
          </Text>
        </VStack>

        {/* {isSelected ? (
        <svg
          id="pause"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g
            id="vuesax_bulk_pause"
            data-name="vuesax/bulk/pause"
          >
            <g id="pause-2" data-name="pause">
              <path
                id="Vector"
                d="M7.65,1.89C7.65.54,7.08,0,5.64,0H2.01C.57,0,0,.54,0,1.89V16.11C0,17.46.57,18,2.01,18H5.64c1.44,0,2.01-.54,2.01-1.89Z"
                transform="translate(3 3)"
                fill={isSelected ? "white" : "#bf8d46"}
              />
              <path
                id="Vector-2"
                data-name="Vector"
                d="M7.65,1.89C7.65.54,7.08,0,5.64,0H2.01C.58,0,0,.54,0,1.89V16.11C0,17.46.57,18,2.01,18H5.64c1.44,0,2.01-.54,2.01-1.89Z"
                transform="translate(13.35 3)"
                fill={isSelected ? "white" : "#bf8d46"}
              />
              <path
                id="Vector-3"
                data-name="Vector"
                d="M24,0V24H0V0Z"
                fill={isSelected ? "white" : "#bf8d46"}
                opacity="0"
              />
            </g>
          </g>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 15.812 16.822"
        >
          <path
            id="Vector"
            d="M0,4.97C0,.527,3.14-1.264,6.978.946L9.956,2.667l2.977,1.721c3.838,2.21,3.838,5.839,0,8.048L9.956,14.158,6.978,15.88C3.14,18.09,0,16.275,0,11.856V4.97Z"
            fill="#bf8d46"
          />
        </svg>
      )} */}
      </HStack>
    </TouchableOpacity>
  );
};

export default memo(SurahItem);
